function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Subscribable } from './subscribable.esm.js';
import { isServer } from './utils.esm.js';
var onlineEvents = ['online', 'offline'];
var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  function OnlineManager() {
    var _this;
    _classCallCheck(this, OnlineManager);
    _this = _callSuper(this, OnlineManager);
    _this.setup = function (onOnline) {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!isServer && window.addEventListener) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online

        onlineEvents.forEach(function (event) {
          window.addEventListener(event, listener, false);
        });
        return function () {
          // Be sure to unsubscribe if a new handler is set
          onlineEvents.forEach(function (event) {
            window.removeEventListener(event, listener);
          });
        };
      }
      return;
    };
    return _this;
  }
  _inherits(OnlineManager, _Subscribable);
  return _createClass(OnlineManager, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      if (!this.cleanup) {
        this.setEventListener(this.setup);
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.hasListeners()) {
        var _this$cleanup;
        (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
        this.cleanup = undefined;
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(setup) {
      var _this2 = this;
      var _this$cleanup2;
      this.setup = setup;
      (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
      this.cleanup = setup(function (online) {
        if (typeof online === 'boolean') {
          _this2.setOnline(online);
        } else {
          _this2.onOnline();
        }
      });
    }
  }, {
    key: "setOnline",
    value: function setOnline(online) {
      var changed = this.online !== online;
      if (changed) {
        this.online = online;
        this.onOnline();
      }
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      this.listeners.forEach(function (_ref) {
        var listener = _ref.listener;
        listener();
      });
    }
  }, {
    key: "isOnline",
    value: function isOnline() {
      if (typeof this.online === 'boolean') {
        return this.online;
      }
      if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
        return true;
      }
      return navigator.onLine;
    }
  }]);
}(Subscribable);
var onlineManager = new OnlineManager();
export { OnlineManager, onlineManager };